// Styles
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'
import * as components from 'vuetify/components'

// Vuetify
import { createVuetify } from 'vuetify'
import { aliases, md } from 'vuetify/iconsets/md'
import { bp_cc2 } from '../theme/blueprint.ts'
import { ecc } from './ecciconset'

const vuetify = createVuetify({
  blueprint: bp_cc2,
  components,
  theme: {
    themes: {
      light: {}
    }
  },
  icons: {
    defaultSet: 'md',
    aliases,
    sets: {
      md,
      ecc
    },
  }
})


export default vuetify